import { combineReducers } from "redux";
import CategoryReducer from "./category/reducer";
import GeneralReducer from "./user/reducer";
import GeneralReducer2 from "./reducers/GeneralSlice";

export const rootReducer = combineReducers({
  general: GeneralReducer,
  category: CategoryReducer,
  business: GeneralReducer2
});